import type { NoDataPluginChartOptions } from './plugins/noDataPlugin';

/**
 * A chart's `options.plugins` with the no-data message coloured `color`, unless the chart
 * sets its own. The wrappers pass the chart theme's text colour, so the message switches
 * with the theme even under a `ChartThemeOverride`, where the Chart.js defaults would still
 * follow the page.
 */
export function withNoDataColor<TPlugins extends { noData?: NoDataPluginChartOptions } | undefined>(
    plugins: TPlugins,
    color: string
): TPlugins & { noData: NoDataPluginChartOptions } {
    return { ...plugins, noData: { color, ...plugins?.noData } };
}
